<template>
    <v-flex sm12 md12 lg12>
 <v-snackbar
      :value="snackbar"
      :color="component.httpStatus == 200 ? 'green' : 'red'"
      :timeout="component.httpStatus == 200 ? 2000 : 0"
      :vertical="false"
    >
      {{component.message}}
      <v-btn
        dark
        flat
        @click="hide = true"
      >
        Close
      </v-btn>
    </v-snackbar>

       
    </v-flex>
</template>
<script>
export default {
  name: "AppAlert",
  props: ["component"],
  data() {
    return {
      hide: false
    };
  },

  computed: {
    snackbar: function() {
      if (this.hide) return false;
      if (this.component.httpStatus !== 0) return true;
    },
    submitted: function() {
      if (this.component.httpStatus === 200) {
        return "success";
      } else return "error";
    }
  }
};
</script>
